import React, { useEffect } from "react";
import { logout } from "../../api/axios";

const AutoLogout: React.FC = () => {
  useEffect(() => {
    const doLogout = async () => {
      try {
        await logout();
      } catch (error) {
        console.error("Logout failed:", error);
      } finally {
        // Reload page regardless of success or failure
        window.location.reload();
      }
    };

    doLogout();
  }, []);

  // Optionally render nothing or a loading message
  return null;
};

export default AutoLogout;
